import CpdForm from '../../common/CpdForm';

export default function UpdateCpdForm() {
    return <CpdForm mode="Update" />;
}
